<template>
  <div>
    <bar-comanda ref="barComanda"/>
    <loading v-if="load" text="Consultando caixa"/>
    <div id="pdv" class="container-fluid p-mobile" v-show="!load">
      <div class="row no-gutters">
        <div class="col-12 mb-3 d-lg-none">
          <menu-pdv :comanda="comanda" v-if="comanda"
                    @editarComanda="$refs.editarComanda.selEditarComanda(comanda)"
                    @openModal="openModal"
                    @openPesquisar="openPesquisar"
                    @finalizaVenda="finalizar"
                    @novaVenda="novaVenda"
                    @cancelarVenda="inicializar"
                    @addCliente="addCliente"
                    @importarComanda="openModal(8)"
          />
        </div>
        <div class="col-lg-8 mb-2 pr-sm-2 pr-lg-0">
          <div class="row no-gutters d-none mb-2 d-lg-flex" v-if="comanda.status === '1' && (menus.includes('4') || comanda.tipo_comanda !== '4')">
            <div class="col-md-8 col-lg-9 pr-2">
              <div class="position-relative">
                <input type="search" class="form-control pr-2" id="pesquisar" placeholder="Pesquisar produto (Alt+P)" v-model="termo.valor" @keyup.enter="pesquisarTermo(termo.valor)">
                <button class="btn btn-sm btn-help" @click="openAjuda" v-show="!termo.valor.length">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-help" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#9454f0" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                    <circle cx="12" cy="12" r="9" />
                    <line x1="12" y1="17" x2="12" y2="17.01" />
                    <path d="M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="col-md-4 col-lg-3 pr-2 d-flex">
              <button class="btn btn-primary btn-block text-nowrap" @click="pesquisarProduto()">
                <i class="fa fa-list-alt mr-1"></i>
                <span style="font-size: 0.95rem">Produtos</span>
              </button>
            </div>
          </div>
          <div class="mb-2 height-95 rounded bg-white border" style="min-height: 180px!important;">
            <div class="table-responsive">
              <table class="table table-borderless table-sm mb-1">
                <thead class="small">
                <tr class="text-white bg-third">
                  <th class="text-left align-middle" style="width: 50%">Produto</th>
                  <th class="align-middle" style="width: 20%">Unitário</th>
                  <th class="align-middle" style="width: 20%">Total</th>
                  <th class="align-middle text-right" style="width: 10%">
                    <a href="javascript:" class="btn  btn-sm text-white" @click="buscarVenda()" title="Sincronizar dados" style="padding: 0 6px 0 6px">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-rotate" width="20" height="20" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5" />
                      </svg>
                    </a>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr class="border-top small" v-for="(p, index) in comanda.itens">
                  <td class="text-left pointer pl-2 py-2" @click="update(p)">
                    <a href="javascript:" class="text-primary"><i class="fa fa-edit mr-2 small"></i></a>
                    <span v-show="p.produto.id_medida === '1'"><b>{{p.quantidade | qtd}}x</b></span>
                    <span v-show="p.produto.id_medida !== '1'"><b>{{p.quantidade | valor}}kg</b></span>
                    {{p.produto.nome_produto}}
                    <span class="badge badge-warning ml-1" v-if="p.id_voucher"><i class="fa fa-ticket-alt mr-1"></i> Voucher</span>
                    <div v-for="d in p.divisoes">
                      # {{d.nome_produto}}
                    </div>
                    <div v-for="a in p.adicionais">
                      + <span>{{(a.id_comanda_produto ? (a.quantidade / p.quantidade) : a.quantidade) | qtdAdc}}</span> {{a.nome_produto}}<span v-show="a.valor > 0">: R$ {{a.valor * a.quantidade | valor}}</span>
                    </div>
                    <div v-show="p.observacao">
                      Obs: <b>{{p.observacao}}</b>
                    </div>
                  </td>
                  <td @click="update(p)">R$ {{p.produto.valor | valor}}</td>
                  <td @click="update(p)">R$ {{p.valor_total | valor}}</td>
                  <td class="text-right">
                    <button class="btn btn-sm" title="Remover item" @click="removerProduto(index, p)" v-show="comanda.status === '1'">
                      <icon-delete/>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="d-sm-flex justify-content-between">
            <div class="mt-2">
              <div class="small" v-if="taxa_servico > 0">
                <b>Taxa:</b> R$ {{taxa_servico | valor}}
              </div>
              <div class="small" v-if="cover > 0">
                <b>Couvert:</b> R$ {{cover | valor}}
              </div>
              <div class="small" v-if="comanda.status !== '1'">
                <b>Troco:</b> R$ {{(comanda.troco ? comanda.troco : 0) | valor}}
              </div>
              <h6 class="text-secondary m-0"><b>Total:</b> R$ {{totalComanda - (comanda.desconto ? comanda.desconto : 0) + taxa_servico + parseFloat(comanda.frete) | valor}}</h6>
            </div>
            <div class="mt-3 mb-2 my-md-0 d-flex justify-content-center flex-wrap" v-if="comanda.id_comanda">
              <button v-if="comanda.tipo_comanda !== '4'" class="btn btn-secondary m-1 py-3" @click="$refs.listPedido.openListPedidos(comanda.id_comanda)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-list-details mr-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M13 5h8" />
                  <path d="M13 9h5" />
                  <path d="M13 15h8" />
                  <path d="M13 19h5" />
                  <rect x="3" y="4" width="6" height="6" rx="1" />
                  <rect x="3" y="14" width="6" height="6" rx="1" />
                </svg>
                <span class="small">Pedidos</span>
              </button>
              <button class="btn btn-third m-1 py-3" @click="opcoesComprovante(comanda, true, false)">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-receipt mr-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                  <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2m4 -14h6m-6 4h6m-2 4h2" />
                </svg>
                <span class="small">Comprovante</span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-4 pl-sm-2 d-none d-lg-block" style="margin-bottom: 36px">
          <menu-pdv :comanda="comanda" v-if="comanda"
                    @editarComanda="$refs.editarComanda.selEditarComanda(comanda)"
                    @openModal="openModal"
                    @openPesquisar="openPesquisar"
                    @finalizaVenda="finalizar"
                    @novaVenda="novaVenda"
                    @cancelarVenda="inicializar"
                    @addCliente="addCliente"
                    @importarComanda="openModal(8)"
          />
        </div>
      </div>

      <div class="fixed-bottom px-3 py-2 bg-white shadow d-lg-none" v-if="comanda.status === '1' && (menus.includes('4') || comanda.tipo_comanda !== '4')">
        <button class="btn btn-third btn-block" style="padding-top: 14px; padding-bottom: 14px" @click="pesquisarProduto()">
          <i class="fa fa-plus mr-2"></i> Adicionar Produto
        </button>
      </div>

      <!--components-->
      <pesquisar-produto ref="pdvPesquisa" pdv="true" @addVoucher="addVoucher" @atualizarPedidos="inserirProdutos" @cancelar="voltarProduto"/>
      <pedido ref="pedidoPdv" :comanda="comanda" @retorno="inicializar"/>
      <detalhes-produto ref="modalDetalhes" :comanda="comanda" @atualizar="atualizarProduto" @atualizarVenda="buscarVenda()" @voltarDetalhes="voltarDetalhes" :disabled="comanda.status !== '1'"/>
      <finalizar ref="finalizar" :comanda="comanda" :totalComanda="totalComanda" @novaVenda="novaVenda(2)" @atualizarVenda="buscarVenda" @comprovante="imprimirVenda"/>
      <lista-pedidos ref="listPedido" :comanda="comanda" @atualizarVenda="inicializar" @editarPedido="editarPedido"/>
      <editar-comanda ref="editarComanda" @atualizarComanda="inicializar" @editarVenda="editarVenda"/>
      <cupom ref="cupom"/>
      <modal-option ref="modalOpt" @atualizar="atualizarNfe" @imprimir="imprimirVenda"/>

      <div v-show="modalPesquisar">
        <admin-vendas :opened="modalPesquisar" @closeModal="openPesquisar(false)" @atualizar="inicializar" :tipo="modal === 2 ? '2': ''"/>
      </div>

      <div class="modal-pdv show" id="modalPDV" tabindex="-1" v-if="modal" :class="[6,7,8].includes(modal) ? 'modal-small' : 'modal-full'">
        <div class="modal-pdv-content p-0">
          <div v-if="modal === 1">
            <mesas-comandas @openMesa="openModal(0)" @atualizar="buscarVenda()"/>
          </div>
          <div v-if="modal === 3">
            <comandas @openComanda="openModal(0)" @atualizar="buscarVenda()" @openImportar="openModal"/>
          </div>
          <div class="container-fluid py-3" v-if="modal === 7">
            <div class="text-center">
              <h5 class="mb-3">Caixa Atual</h5>
              <div class="alert alert-warning">
                <i class="fa fa-exclamation-triangle mr-1"></i> Aberto a mais de <b>{{ caixa.horas }} horas</b>
              </div>
            </div>
            <ul class="list-group mb-3" v-if="caixa">
              <li class="list-group-item">Caixa: <b>#{{caixa.id_caixa}}</b></li>
              <li class="list-group-item">Aberto em: <b>{{ caixa.dt_cadastro }}</b></li>
              <li class="list-group-item">Colaborador: <b>{{ caixa.nome }}</b></li>
            </ul>
            <div class="text-center">
              <a href="javascript:" class="btn btn-secondary btn-block" @click="openCaixa()">Fechar Caixa</a>
            </div>
          </div>
          <div v-if="modal === 8">
            <div class="px-3 pt-3">
              <h6 class="font-weight-bold mb-3 text-center text-dark">Comandas</h6>
              <div class="alert small d-flex align-items-center" :class="importada ? 'alert-success' : 'alert-warning'">
                <i class="fa mr-2" :class="importada ? 'fa-check' : 'fa-info-circle'"></i>
                <div>{{ importada || 'Os produtos serão importados na comanda atual' }}</div>
              </div>
              <div class="mb-3">
                <input type="number" class="form-control" placeholder="Número da comanda. Ex: 123" v-model="term_comanda" id="termComandaImp"
                       @keyup.enter="importarComanda(term_comanda)" :disabled="load">
              </div>
            </div>
          </div>
          <div class="modal-content-footer bg-light p-2 border-top text-center" v-if="modal === 7">
            <button class="btn btn-success p-3" @click="openModal(0)">Continuar <i class="fa fa-angle-right ml-1"></i></button>
          </div>
          <div class="modal-content-footer bg-light p-2 border-top d-flex justify-content-between" v-else-if="modal === 8">
            <button class="btn btn-dark p-3" @click="openModal(0)">
              <i class="fa fa-chevron-left mr-2"></i>
              <span>Voltar</span>
            </button>
            <button class="btn btn-success py-3 px-4" @click="importarComanda()">{{term_comanda ? 'Importar' : 'Fechar Conta'}}</button>
          </div>
          <div class="modal-content-footer bg-light p-2 border-top" v-else>
            <button class="btn btn-dark p-3" @click="openModal(0)">
              <i class="fa fa-chevron-left mr-2"></i>
              <span>Voltar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PesquisarProduto from "./PesquisarProduto"
  import DetalhesProduto from "./DetalhesProduto";
  import IconCategoria from "../../../components/pdv/IconCategoria";
  import MesasComandas from "../comanda/MesasComandas";
  import Comandas from "../comanda/Comandas";
  import EditarComanda from "./EditarComanda";
  import Cupom from "./Cupom";
  import TopBar from "@/components/commons/TopBar";
  import NovaVenda from "./NovaVenda";
  import MenuPdv from "./MenuPdv";
  import ModalOption from "@/components/pdv/ModalOption";
  import IconDelete from "../../../components/pdv/IconDelete";
  import BarComanda from "@/components/pdv/BarComanda";
  import Loading from "@/components/commons/Loading";

  export default {
    components: {
      Loading,
      BarComanda,
      IconDelete,
      ModalOption,
      MenuPdv,
      NovaVenda,
      TopBar,
      Cupom, EditarComanda, Comandas,
      MesasComandas, IconCategoria, DetalhesProduto, PesquisarProduto},
    name: "pdv",

    data() {
      return {
        token: localStorage.getItem('key'),
        empresa: localStorage.getItem('token'),
        load: true,
        caixa: null,
        callback: null,
        comanda: {
          itens: [],
          id_cliente: false,
          frete: 0,
          desconto: 0,
          pagamentos: [],
          tipo_comanda: 0,
          status: '1',
          cliente: {}
        },
        termo: {
          valor: '',
          quantidade: 1
        },

        modal: 0,
        modalPesquisar: false,
        totalComanda: 0.00,
        taxa_servico: 0.00,
        cover: 0.00,
        produto: null,

        importada: null,
        term_comanda: ''
      }
    },

    methods: {
      buscarVenda(focus, imprimir, callback) {
        const id = this.$route.params.id;
        focus = this.$route.query.noFocus ? false : focus;

        if (isNaN(Number.parseInt(id))) {
          this.$store.state.load = false;
          this.novaVenda();
          return;
        }

        this.taxa_servico = 0.00;
        this.totalComanda = '0.00';
        this.$store.state.load = true;

        this.$http.get('comandas/' + this.token + '/' + id)
          .then(response => {
            this.$store.state.load = false;

            if (response.data.id_comanda) {
              this.comanda = response.data || {};
              this.totalizar();
              this.$nextTick(() => {
                if (this.callback) {
                  this.callback();
                  this.callback = null;

                } else if (focus && this.comanda.status === '1') {
                  this.$helpers.focusElement('pesquisar');
                }

                if (imprimir) {
                  this.opcoesComprovante(this.comanda, false, true);

                } else if (callback) {
                  callback();
                }
              });
            }

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário").then(() => {
              if (res.status === 400) {
                this.$router.push('/pdv/venda-rapida')
              }
            });
          });
      },

      verificarPDV(status) {
        return parseInt(this.comanda.status) === status;
      },

      opcoesComprovante(comanda, reimprimir, finalizar) {
        if (comanda.status === '1') {
          this.imprimirVenda();

          if (this.isElectron && this.$store.state.printLocal) {
            this.$swal("Enviado para impressora");
          }

        } else {
          this.$refs.modalOpt.abrirComprovante(comanda, reimprimir, finalizar);
        }
      },

      imprimirVenda() {
        const id_comanda = this.comanda.id_comanda;
        this.$refs.cupom.processarDados(this.comanda, this.totalComanda, () => {
          const cf = this.$store.state.impressora;
          const html = document.getElementById('cupomVenda');

          if (html) {
            const device = cf.devicePdv || null;
            const dataImpressao = {
              content: html.innerHTML,
              copies: 1,
              isPdv: true,
              status: 1,
              nome_documento: `Comprovante Venda: ${this.comanda.id_contador || id_comanda}`,
              device,
              impressora: {
                device,
                zoom: cf.zoom || "9px",
                largura: cf.largura || '100%'
              }
            };

            this.$helpers.imprimirComprovante(this, this.empresa, [dataImpressao], cf.mobilePrint);
          }
        });
      },

      voltarProduto() {
        this.termo.valor = '';
        this.termo.quantidade = 1;
        this.$helpers.focusElement('pesquisar');
      },

      inserirProdutos(lista) {
        this.termo.quantidade = 1;
        this.termo.valor = '';

        if (!lista || !lista.length) {
          return;
        }

        if (!this.comanda.id_comanda) {
          lista.forEach(item => {
            if (this.comanda.itens.find(p => p.id_voucher && p.id_voucher === item.id_voucher)) {
              this.$swal("Voucher já adicionado nesta venda!");
              return;
            }

            this.comanda.itens.unshift({ ...item, voucher: null });
          });

          this.totalizar();
          this.$helpers.focusElement('pesquisar');

        } else {
          this.salvarVenda(lista);
        }
      },

      addVoucher() {
        this.$swal("Para adicionar este voucher, clique em Fechar Conta e informe o código de validação.");
      },

      salvarVenda(lista, noRedirect) {
        this.$store.state.load = "Salvando a venda";

        const dados = {
          id_comanda: this.comanda.id_comanda || null,
          tipo_comanda: this.comanda.tipo_comanda,
          id_cliente: this.comanda.id_cliente || null,
          id_catalogo: this.id_catalogo,
          itens: lista
        }

        this.$http.post("pdv/produtos/" + this.token, dados)
          .then(res => {
            this.comanda.id_comanda = res.data.id_comanda;
            this.$store.state.load = false;

            if (!dados.id_comanda && (!noRedirect && res.data.id_comanda)) {
              this.$router.push('/pdv/' + res.data.id_comanda);

            } else if (dados.id_comanda) {
              this.buscarVenda(lista[0].produto.id_medida === '1');
            }

          }, res => {
            console.log(res);
            this.$store.state.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          });

        this.termo = {
          valor: '',
          quantidade: 1
        }
      },

      update(p) {
        this.produto = p;
        this.$refs.modalDetalhes.editarProduto(p);
      },

      voltarDetalhes() {
        this.produto = null;
        this.$helpers.focusElement('pesquisar');
      },

      atualizarProduto(p) {
        if (this.produto) {
          let produto = this.comanda.itens.find((item) => item === this.produto);
          let index = this.comanda.itens.indexOf(produto);
          if (index !== -1) this.comanda.itens.splice(index, 1);
          this.comanda.itens.splice(index, 0, p);
          this.produto = null;
          this.totalizar();

        } else if (p.id_tabela_preco === 'REF001') {
          this.inserirProdutos([p]);
        }
      },

      removerProduto(index, p) {
        if (!p.produto.id_comanda_produto) {
          this.$helpers.confirmarSenhaAdm(this, () => {
            this.comanda.itens.splice(index, 1);
            this.totalizar();
            this.$helpers.focusElement('pesquisar');
          });

        } else {
          this.$helpers.confirmarSenhaAdm(this, this.removerProdutoVenda, p);
        }
      },

      removerProdutoVenda(dados) {
        this.$swal({
          title: '',
          text: 'Deseja remover este produto?',
          buttons: ['Cancelar', 'Sim'],
          dangerMode: true
        }).then((result) => {
          if (result) {
            const datosProduto = { id_comanda_produto: dados.produto.id_comanda_produto, id_comanda: this.comanda.id_comanda };
            this.$store.state.load = true;
            this.$http.post("pdv/produtos/remover/" + this.token, datosProduto).then(res => {
              this.$store.state.load = false;

              if (res.data && res.data.success) {
                this.buscarVenda();

                if (this.$store.state.pdv.automatico === '2') {
                  return;
                }

                this.$swal({
                  text: "Deseja imprimir a guia de cancelamento do item?",
                  buttons: ["Não", "Sim"]
                }).then((resposta) => {
                  if (resposta) {
                    let content = `<div style="font-family: sans-serif">
                    <div style="text-align: center;">
                        <b>*** CANCELAMENTO DE ITEM ***</b><br>
                        ${this.$helpers.getTipoComanda(this.comanda)}<br>
                        Venda: ${res.data.venda} ${res.data.pedido ? ('- Pedido: ' + res.data.pedido) : ''} <br>
                        Horário de cancelamento: ${res.data.horario} <br>
                        Atendente: ${res.data.atendente}
                        <hr>
                    </div>
                    <b>Produto</b><br>
                    ${parseFloat(dados.quantidade).toFixed(dados.produto.id_medida === '2' ? 2 : 0)}x ${dados.produto.nome_produto}`;

                    if (dados.divisoes && dados.divisoes.length) {
                      dados.divisoes.forEach(d => {
                        content += `<div># ${d.nome_produto}</div>`;
                      });
                    }

                    if (dados.adicionais && dados.adicionais.length) {
                      dados.adicionais.forEach(a => {
                        content += `<div> + ${(a.quantidade / dados.quantidade).toFixed()}x ${a.nome_produto}</div>`;
                      });
                    }

                    if (dados.observacao) {
                      content += `<div><b>Obs: </b>${dados.observacao}</div>`;
                    }

                    content += '</div>';
                    const cf = this.$store.state.impressora;
                    const device = res.data.device || cf.devicePdv || null;
                    const dataImpressao = {
                      content,
                      copies: 1,
                      isPdv: true,
                      status: 1,
                      nome_documento: 'Cancelamento de item: ' + dados.id,
                      device,
                      impressora: {
                        device,
                        zoom: cf.zoom || "9px",
                        largura: cf.largura || '100%'
                      }
                    };

                    this.$helpers.imprimir(this, this.empresa, [dataImpressao], cf.mobilePrint);
                  }
                });

              } else {
                this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
              }

            }, res => {
              this.$store.state.load = false;
              this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
            });
          }
        });
      },

      finalizar() {
        if (this.modal) {
          this.openModal(0);
        }

        if (this.comanda.id_comanda) {
          this.$refs.finalizar.openFinalizar();

        } else if (this.comanda.itens.length) {
          if (this.usuario.id_funcao < 3 && !this.finalizarBloqueado) {
            this.callback = () => { this.$refs.finalizar.openFinalizar(); }
          }

          this.salvarVenda(this.comanda.itens);
        }
      },

      closeModals() {
        this.$refs.pedidoPdv.closeModals();
        this.$refs.pdvPesquisa.closePesquisar();
      },

      inicializar() {
        this.closeModals();
        this.$helpers.scrollTop("pdv");
        this.$store.state.load = true;
        this.taxa_servico = 0.00;
        this.totalComanda = '0.00';
        let tipoComanda = this.$route.name;
        let id = this.$route.params.id;
        this.comanda = {
          status: '1',
          itens: [],
          id_cliente: null,
          frete: 0,
          desconto: 0,
          pagamentos: [],
          tipo_comanda: '4',
          valor_total: 0.00,
          cliente: null
        };

        if (id && isNaN(id)) {
          this.$router.push('/pdv');
          return;
        }

        switch (tipoComanda) {
          case "NovoPDVID":
            this.buscarVenda(true, false, () => {
              if (!!this.$route.query.finalizar && this.comanda.status === '1') {
                this.$refs.finalizar.openFinalizar();
              }
            });
            break;

          case "NovoPDVMesa":
            this.comanda.tipo_comanda = '1';
            this.comanda.mesa = id;
            this.$nextTick(() => {
              this.selecionarCategoria(null);
            });
            break;

          case "NovoPDVDelivery":
            this.comanda.tipo_comanda = '2';
            this.$nextTick(() => {
              this.selecionarCategoria(null);
            });
            break;

          case "NovoPDVComanda":
            this.comanda.tipo_comanda = '3';
            this.comanda.ref_comanda = id;
            this.$nextTick(() => {
              this.selecionarCategoria(null);
            });
            break;

          case "NovoPDVBalcao":
            this.comanda.tipo_comanda = '5';
            this.$nextTick(() => {
              this.selecionarCategoria(null);
            });
            break;

          case "NovoPDV":
            this.comanda.tipo_comanda = '4';

            if (!!this.$route.query.novaMesa) {
              this.openModal(1);

            } else if (!!this.$route.query.novaComanda) {
              this.openModal(3);

            } else {
              this.$helpers.focusElement('pesquisar');
            }

            break;

          default:
            this.comanda.tipo_comanda = '4';

            this.$nextTick(() => {
              if (this.configs.priorizar_codigo !== '1') {
                this.pesquisarProduto();

              } else {
                this.$helpers.focusElement('pesquisar');
              }
            });

            break;
        }

        if (tipoComanda !== "NovoPDVID") {
          this.$store.state.load = false;
        }
      },

      totalizar() {
        let total = 0;
        this.comanda.itens.forEach((obj) => {
          total += parseFloat(obj.valor_total);
        });

        this.totalComanda = parseFloat(total.toFixed(2));

        if (this.totalComanda > 0 && ['1','3'].includes(this.comanda.tipo_comanda)) {
          if (this.comanda.status === '1') {
            const taxa = this.$store.state.pdv.taxa_servico || 0;
            this.taxa_servico = taxa > 0 ? (this.totalComanda * taxa / 100) : 0;

          } else {
            this.taxa_servico = parseFloat(this.comanda.taxa_servico || '0');
          }
        }
      },

      novaVenda(tipo) {
        this.openModal(0);

        switch (tipo) {
          case 2:
            if (this.$route.name !== 'NovoPDVDelivery') {
              this.$router.push('/pdv/delivery');

            } else {
              this.selecionarCategoria(null);
            }

            break;

          case 5:
            if (this.$route.name !== 'NovoPDVBalcao') {
              this.$router.push('/pdv/balcao');

            } else {
              this.selecionarCategoria(null);
            }

            break;

          default:
            if (this.$route.name !== 'NovoPDVVendaRapida') {
              this.$router.push('/pdv/venda-rapida');

            } else {
              this.pesquisarProduto();
            }

            break;
        }
      },

      openModal(n) {
        this.modal = n;
        this.$nextTick(() => {
          this.$helpers.toggleModal(n, 'modalPDV', this.openModal);

          if (!n) {
            this.$helpers.focusElement('pesquisar');

          } else if (n === 8) {
            this.importada = null;
            this.term_comanda = '';
            this.$helpers.focusElement('termComandaImp');
          }
        });
      },

      openPesquisar(n) {
        this.modalPesquisar = n;
        this.$nextTick(() => {
          this.$helpers.toggleModal(n, 'modalPesquisar', this.openPesquisar);
        });
      },

      atualizarNfe(nfe) {
        this.comanda.id_nfe = nfe.id_nfe;
      },

      editarPedido(pedido) {
        this.$refs.pedidoPdv.editarPedido(pedido);
      },

      pesquisarTermo(termo) {
        if (termo && termo.trim()) {
          this.pesquisarProduto(this.termo, !isNaN(termo));

        } else if (this.configs.priorizar_codigo !== '1') {
          this.pesquisarProduto();
        }
      },

      pesquisarProduto(termo) {
        termo = termo || { quantidade: 1, valor: '' }
        termo.quantidade = termo.quantidade > 0 ? termo.quantidade : '1';

        if (termo.valor.includes('*')) {
          const tm = termo.valor.split('*');

          if (tm && tm.length === 2) {
            termo.quantidade = tm[0] && !isNaN(tm[0]) ? tm[0] : 1;
            termo.valor = tm[1];
          }
        }

        if (this.comanda.tipo_comanda === '4') {
          if (termo.valor === '001') {
            this.$refs.modalDetalhes.editarProduto({
              "id_tabela_preco": "REF001",
              "quantidade": `${termo.quantidade}.0000`,
              "desconto": "0.00",
              "observacao": "",
              "produto": {
                "id_produto": "000",
                "valor": "0.00",
                "valor_total": "0.00",
                "nome_produto": "Diversos",
                "id_medida": "1",
                "total": "0.00"
              },
              "adicionais": [],
              "valor_total": "0.00",
              "divisoes": []
            });

          } else {

            this.$refs.pdvPesquisa.pesquisarProduto(JSON.parse(JSON.stringify(termo)), !isNaN(termo.valor), (res) => {
              if (!res) {
                this.$swal('Código não encontrado').then(() => {
                  this.$helpers.focusElement('pesquisar');
                });
              }
            });
          }

        } else if (this.comanda.id_comanda && this.comanda.tipo_comanda === '2') {
          this.$refs.listPedido.editarPedidoDelivery(this.comanda.id_comanda)

        } else {
          this.$refs.pedidoPdv.abrirPedido(JSON.parse(JSON.stringify(termo)));
        }

        this.termo.valor = "";
        this.termo.quantidade = 1;
      },

      selecionarCategoria(c, valor) {
        const termo = {valor: '', quantidade: 1};

        if (c) {
          termo.categoria = c.id_categoria;
          termo.valor = c.nome_categoria;

        } else if (valor) {
          termo.valor = valor;
        }

        if (this.comanda.tipo_comanda === '4') {
          if (this.configs.priorizar_codigo !== '1') {
            this.$refs.pdvPesquisa.pesquisarProduto(termo);

          } else {
            this.$helpers.focusElement('pesquisar');
          }

        } else if (this.comanda.id_comanda && this.comanda.tipo_comanda === '2') {
          this.$refs.listPedido.editarPedidoDelivery(this.comanda.id_comanda)

        } else if (this.is_mobile || this.configs.priorizar_codigo !== '1') {
          this.$refs.pedidoPdv.abrirPedido(termo);

        } else {
          this.$helpers.focusElement('pesquisar');
        }
      },

      editarVenda(dados) {
        this.comanda.observacao = dados.observacao || null;
        this.comanda.id_cliente = dados.id_cliente || null;
        this.comanda.cliente = dados.cliente ? dados.cliente : {};
      },

      addCliente() {
        if (this.comanda.id_cliente) {
          this.comanda.id_cliente = null;
          this.comanda.cliente = {};

        } else {
          this.$refs.editarComanda.selEditarComanda(this.comanda, true);
        }
      },

      handler(e) {
        if (e.altKey) {
          switch (e.keyCode) {
            case 49:
              // 1 - Venda Rapida
              e.preventDefault();
              this.closeModals();
              this.novaVenda();
              break;

            case 50:
              // 2 - Balcao
              e.preventDefault();
              this.closeModals();
              this.novaVenda(5);
              break;

            case 51:
              // 3 - Mesa
              e.preventDefault();
              this.closeModals();
              this.openModal(1);
              break;

            case 52:
              // 4 - Delivery
              e.preventDefault();
              this.closeModals();
              this.novaVenda(2);
              break;

            case 53:
              // 5 - Comanda
              e.preventDefault();
              this.closeModals();
              this.openModal(3);
              break;

            case 55:
              // 6 - Pesquisar
              e.preventDefault();
              this.closeModals();
              this.openPesquisar(true);
              break;

            case 57:
              // 9
              e.preventDefault();
              this.closeModals();
              this.finalizar();
              break;
            case 80:
              // ALT+P
              e.preventDefault();
              this.closeModals();
              this.selecionarCategoria(null);
              break;
          }
        }
      },

      openAjuda() {
        const text = `Digite o código ou nome do produto e aperte a tecla "Enter" para adicionar ou pesquisar o item desejado.

        Atalhos do Sistema:
        001 - Produto diversos
        002 - Taxa de Entrega`
        this.$swal(text)
      },

      verificarCaixa() {
        this.load = true;
        this.$http.get("caixas/consultar/" + this.token)
          .then(res => {
            this.load = false;
            const caixa = res.data;

            if (caixa && caixa.id_caixa && caixa.horas >= 6) {
              this.caixa = caixa;
              this.openModal(7);
            }

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      openCaixa() {
        this.openModal(null);
        this.$refs.barComanda.openCaixa();
      },

      importarComanda() {
        if (!this.term_comanda || isNaN(this.term_comanda)) {
          this.finalizar();
          return;
        }

        this.$store.state.load = true;
        this.$http.post("pdv/comanda/transferir/" + this.token, { id_comanda: this.comanda.id_comanda, ref_comanda: this.term_comanda })
          .then(res => {
            this.$store.state.load = false;
            const data = (res.data || {});
            this.term_comanda = '';
            this.importada = data.success ? "Comanda importada com sucesso!" : null;

            if (data.success) {
              this.buscarVenda(false);

            } else if (!this.comanda.id_comanda && data.id_comanda) {
              this.$router.push(`/pdv/${data.id_comanda}?noFocus=true`);
            }

            if (data.msg) {
              this.$swal(data.msg).then(() => {
                this.$helpers.focusElement('termComandaImp');
              });

            } else {
              this.$helpers.focusElement('termComandaImp');
            }

          }, res => {
            this.$store.state.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      }
    },

    mounted() {
      if (this.usuario.habilitar_comanda !== '1') {
        this.$router.push('/home');
        return;
      }

      this.inicializar();
    },

    created() {
      window.addEventListener('keydown', this.handler);

      if (this.usuario.id_funcao < 3 && this.$store.state.pdv.habilitar_caixa === '1') {
        this.verificarCaixa();

      } else {
        this.load = false;
      }
    },

    beforeDestroy() {
      window.removeEventListener('keyup', this.handler);
    },

    beforeRouteLeave(to, from, next) {
      if (!this.comanda.id_comanda && this.comanda.itens.length) {
        this.$swal({
          title: '',
          text: 'Deseja salvar esta venda?',
          buttons: ['Não','Sim']
        }).then((r) => {
          if (r) {
            this.salvarVenda(this.comanda.itens, true);
          }

          next();
        });

      } else {
        next();
      }
    },

    computed: {
      categorias() {
        return this.$store.state.categorias
      },

      termosRapidos() {
        return this.$store.state.termosRapidos
      },

      usuario() {
        return this.$store.state.dataUser
      },

      configs() {
        return this.$store.state.pdv.json_config;
      },

      catalogos() {
        return this.$store.state.catalogos;
      },

      menus() {
        return this.$store.state.dataUser.acessos.menus;
      },

      finalizarBloqueado() {
        return this.usuario.acessos.bloquear_finalizar === '1';
      },

      id_catalogo() {
        return this.$store.state.id_catalogo;
      }
    },

    filters: {
      valor(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(2);
        }
      },

      qtd(value) {
        return parseFloat(value && !isNaN(value) ? value : '1').toFixed();
      },

      qtdAdc(value) {
        let qtd = parseFloat(value && !isNaN(value) ? value : '1');
        return qtd > 1 ? (qtd.toFixed() + 'x') : '';
      }
    },

    watch: {
      $route (to, from){
        this.inicializar();
      }
    }
  }
</script>

<style>
  .table td {
    vertical-align: middle!important;
  }

  #pdv {
    padding-left: 15px;
    padding-right: 15px;
  }
</style>
